import { render } from "./Breach.vue?vue&type=template&id=17b21ce6"
import script from "./Breach.vue?vue&type=script&lang=js"
export * from "./Breach.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__